import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Avatar, Grid } from '@material-ui/core';
import { PrimaryButton, Text } from 'library';
import { Colors } from '../../constants';
import apiClient from '../../shared/ApiClient';
import { consoleLogInDev } from '../../shared/Utils';
import ILimitedProviderType from './models';
import { goToPartialSignup } from './provider-home-page/ProviderHomeConstants';
import { CenterOtherCardsProps } from './provider-home-page/ProviderHomeModels';
import usePublicSessionTracking, { PublicSessionEventType } from '../shared/PublicSessionTracking';

const fallbackProfileImageSrc = require('../../assets/images/default-sitter.png');
const baseUrl = window.location.origin;

export default function TopProvider({ otherCopy, centerHeader = false, overrideClick }: CenterOtherCardsProps) {
    const [providers, setProviders] = useState<ILimitedProviderType[]>();
    const { trackSession } = usePublicSessionTracking('Top Providers');

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        await apiClient('api/babysitters/top-providers/')
            .then((result) => {
                setProviders(result);
            })
            .catch((error) => {
                consoleLogInDev(error);
            });
    };

    const providerAvatar = (provider: ILimitedProviderType) => {
        return (
            <Grid>
                <Avatar
                    src={provider.profile_picture.image ? provider.profile_picture.image : fallbackProfileImageSrc}
                    style={{ width: 100, height: 100, borderRadius: 10, cursor: 'pointer' }}
                >
                    <img src={fallbackProfileImageSrc} className="MuiAvatar-img" alt="" />
                </Avatar>
            </Grid>
        );
    };

    const openProviderProfile = (provider: ILimitedProviderType) => {
        if (!!overrideClick) {
            overrideClick();
        } else {
            trackSession('NAVIGATE_FROM', 'To Provider Profile', PublicSessionEventType.User, {
                provider_id: provider.id,
                user_uuid: provider.uuid,
            });
            const url = `${baseUrl}/provider/${provider.user_id}`;
            window.open(url);
        }
    };

    const navigateToSignup = () => {
        trackSession('NAVIGATE_FROM', 'To Partial Signup Page', PublicSessionEventType.User);
        goToPartialSignup();
    };

    return (
        <Grid container direction="row">
            <Grid container direction="column" alignItems={centerHeader ? 'center' : 'flex-start'}>
                <Grid item style={{ paddingLeft: 12, paddingRight: 12, paddingBottom: 24, paddingTop: 24 }}>
                    <Text variant="h1">{otherCopy ? `${otherCopy}` : 'Top Tandem Providers'}</Text>
                </Grid>

                {!otherCopy ? (
                    <Grid item style={{ paddingLeft: 12, paddingRight: 12, paddingBottom: 12 }}>
                        <Text variant="body1">
                            Join our network of providers to get a flexible schedule and jobs with no fees attached.
                            Ever.
                        </Text>
                    </Grid>
                ) : null}
            </Grid>
            <Grid
                container
                direction="row"
                item
                xs={12}
                style={{ ...styles.container, flexWrap: 'nowrap', overflowX: 'scroll' }}
            >
                <Grid
                    container
                    item
                    direction="row"
                    xs={12}
                    style={{
                        padding: 12,
                        overflowX: 'scroll',
                        flexWrap: 'nowrap',
                    }}
                >
                    {!!providers
                        ? providers.map((provider, index) => (
                              <Grid
                                  container
                                  item
                                  direction={isMobile ? 'row' : 'column'}
                                  justify="center"
                                  xs={8}
                                  md={3}
                                  lg={2}
                                  style={{ ...styles.card, position: 'relative' }}
                              >
                                  <Grid item style={{ alignSelf: 'center', paddingBottom: 12 }}>
                                      <Text variant="h2" bold>
                                          {provider.name}
                                      </Text>
                                  </Grid>
                                  <Grid item style={{ alignSelf: 'center' }}>
                                      {providerAvatar(provider)}
                                  </Grid>
                                  <Grid item style={{ paddingTop: 12 }}>
                                      <PrimaryButton onClick={() => openProviderProfile(provider)}>
                                          View Profile
                                      </PrimaryButton>
                                  </Grid>
                              </Grid>
                          ))
                        : null}
                    {!!providers ? (
                        <Grid
                            container
                            item
                            direction={isMobile ? 'row' : 'column'}
                            justify="center"
                            xs={8}
                            md={3}
                            lg={2}
                            style={{ ...styles.card, position: 'relative' }}
                        >
                            <Grid item style={{ alignSelf: 'center', paddingBottom: 12 }}>
                                <Text variant="h2" bold>
                                    Create your own free profile at
                                </Text>
                            </Grid>
                            <Grid item>
                                <PrimaryButton onClick={navigateToSignup}>Tandem</PrimaryButton>
                            </Grid>
                        </Grid>
                    ) : null}
                </Grid>
            </Grid>
        </Grid>
    );
}

const styles = {
    container: {
        backgroundColor: 'rgba(243, 255, 208, 0.5)',
        padding: 24,
        borderRadius: 20,
    },
    card: {
        flexShrink: 0,
        alignContent: 'center',
        overflow: 'visible',
        borderRadius: 18,
        marginRight: 24,
        boxShadow: '0px 3px 3px rgba(0,1,1,0.15)',
        backgroundColor: Colors.white,
        maxHeight: 375,
        padding: 12,
    },
};
